<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-height="680"
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
    class="vb-dialog vb-dialog-danger"
  >
    <v-card v-cloak>
        <v-card-title class="d-flex justify-space-between">
        {{ $t('console.deleteOwnTenant') }}

        <v-btn icon @click="dialog = false;">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        </v-card-title>

        <v-card-text scrollable class="scrollable mt-4">
          <v-form @submit.prevent="submitForm" ref="form">
            <h3> {{ $t('console.deleteOwnTenantWarning') }} </h3>
            <div class="mt-4">
              <p>
                {{ $t('console.deleteOwnTenantDescription') }}
              </p>

              <p>
                {{ $t('console.deleteOwnTenantDescription2') }}
              </p>
            </div>

            <div class="mt-2">
              <p>
                {{ $t('console.deleteOwnTenantDescription3') }}
              </p>

              <v-text-field
                v-model="deleteTenantText"
                variant="solo-filled" flat
                class="mt-4"
                hide-details="auto"
              />
            </div>

            <v-row class="mt-4">
              <v-col>
                <div v-if="errorMessage" class="bg-error mb-4" style="width: 100%;">
                  {{ errorMessage }}
                </div>
                <div v-if="isSuccess" class="bg-success mb-4" style="width: 100%;">
                  {{ $t('console.deleteOwnTenantSuccess') }}
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>


        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" class="bg-red-darken-3" elevation=0 @click="submitForm()"
                v-bind:loading="isSubmitted" v-bind:disabled="isDisabled">
            {{ $t('common.delete') }}
        </v-btn>
        <v-btn variant="text" @click="dialog = false">{{ $t('common.close') }}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js';
import { useTenantStore } from '@/stores/TenantStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [ DialogActionKeys, DialogModel ],
  name: 'DeleteTenantDialog',
  data() {
    return {
      isSubmitted: false,
      isSuccess: false,

      errorMessage: '',
      successMessage: '',

      deleteTenantText: "",
    };
  },
  watch: {
    dialog: function() {
      this.resetForm();
    },
  },
  methods: {
    resetForm() {
      this.isSubmitted = false;
      this.isSuccess = false;
      this.errorMessage = '';
      this.successMessage = '';

      this.deleteTenantText = "";
    },
    async submitForm() {
      const { valid } = await this.$refs.form.validate();

      if (!valid || this.isDisabled) {
        console.log("Not valid")
        return;
      }

      try {
        this.isSubmitted = true;
        this.errorMessage = '';
        this.successMessage = '';

        const tenantStore = useTenantStore();
        await tenantStore.deleteOwnTenant(this.rootNodeId);

        this.isSuccess = true;

        setTimeout(() => {
          this.$router.push('/account/logout');
        }, 3000);
      } catch (error) {
        console.error(error);
        console.error(error.response.data.error);

        if (error?.response?.data?.error) {
          this.errorMessage = this.$localizeMessage(error.response.data.error);
        } else {
          this.errorMessage = this.$t('backend.system-error');
        }
      } finally {
        this.isSubmitted = false;
      }
    },
  },
  computed: {
    rootNodeId: function () {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    isDisabled() {
      return this.isSubmitted
          || (this.deleteTenantText.toLowerCase() !== "delete");
    },
  },
}
</script>

<style>
</style>
